/** Transparent line art inspired by the supplied Hanuman ji profile. */
export default function HanumanSVG({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 160 180" xmlns="http://www.w3.org/2000/svg"
      className={className} role="img" aria-label="Hanuman ji, a symbol of devotion and strength">
      <g fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round">
        <path strokeWidth="2.6" d="M38 39 C53 28 76 34 91 52 C79 35 59 29 45 35" />
        <path strokeWidth="2.4" d="M45 57 C60 60 72 58 85 69 C73 64 63 62 54 63" />
        <path strokeWidth="2.2" d="M62 66 C64 73 70 76 76 74 M62 66 C66 70 70 71 74 71" />
        <path strokeWidth="2.8" d="M105 27 C102 40 95 52 97 62 C98 70 105 67 109 57 C113 47 111 41 110 36 M107 35 C106 44 101 56 102 61" />
        <path strokeWidth="2.4" d="M99 77 C94 88 98 100 96 111 C95 118 100 123 96 126 C93 128 88 125 85 123 M85 115 C79 121 83 126 88 125" />
        <path strokeWidth="1.7" d="M94 132 C93 135 92 138 89 139 L84 137 M91 143 C88 145 85 144 82 143" />
        <path strokeWidth="2.1" d="M96 140 C94 146 90 152 84 153 C77 153 73 149 70 144 C66 137 62 133 56 135" />
        <path strokeWidth="1.8" d="M65 146 C70 151 75 158 83 158 C88 158 93 154 96 150 M83 158 C75 167 66 172 55 172" />
      </g>
    </svg>
  );
}
